/* Apercu flottant Easify (fiches avec apercu en direct uniquement) */
(function () {
  if (window.__cfpInit) return;
  window.__cfpInit = true;
  var MAX_WIDTH = 999; // mobile et tablette uniquement
  var tries = 0;

  // Empeche le debordement horizontal du canvas Easify (pleine largeur a -20px) sur mobile
  var fix = document.createElement('style');
  fix.textContent = 'html,body{overflow-x:hidden}@supports (overflow:clip){html,body{overflow-x:clip}}.tpo_canvas_builder{overflow:clip;overflow-clip-margin:24px}' +
    // Sur ecran tactile, la bulle de zoom des pastilles reste affichee apres un appui et deborde sur l'option du dessus
    '@media (hover:none){.tpo_image-swatches-tooltip{display:none!important}}';
  document.head.appendChild(fix);

  function start() {
    var builder = document.querySelector('.tpo_canvas_builder');
    if (!builder || !window.Konva || !Konva.stages || !Konva.stages.length) {
      if (++tries < 60) setTimeout(start, 500);
      return;
    }
    var stage = Konva.stages[0];

    // L'apercu n'est pas interactif pour le client : on coupe les evenements Konva
    // (sinon le toucher sur l'image bloque le defilement de la page) et on limite
    // la densite des canvas a 2x pour alleger les redessins sur mobile.
    function harden() {
      try {
        if (stage.listening()) stage.listening(false);
        stage.find(function () { return true; }).forEach(function (n) {
          if (n.draggable && n.draggable()) n.draggable(false);
          if (n.preventDefault && n.preventDefault()) n.preventDefault(false);
        });
        stage.getLayers().forEach(function (l) {
          var cv = l.getCanvas();
          if (cv.getPixelRatio() > 2) {
            cv.setPixelRatio(2);
            l.batchDraw();
          }
        });
      } catch (e) {}
    }
    harden();
    setTimeout(harden, 1500);

    var anchor = builder.closest('product-gallery') || builder.closest('.product-gallery') || builder;

    var css = document.createElement('style');
    css.textContent =
      '.cfp-thumb{position:fixed;left:12px;bottom:90px;z-index:60;width:96px;height:96px;padding:0;border:3px solid #fff;border-radius:14px;background:#fff;box-shadow:0 6px 20px rgba(0,0,0,.22);overflow:hidden;cursor:pointer;opacity:0;transform:translateY(12px) scale(.9);pointer-events:none;transition:opacity .25s,transform .25s}' +
      '.cfp-thumb.is-on{opacity:1;transform:none;pointer-events:auto}' +
      '.cfp-thumb img{width:100%;height:100%;object-fit:contain;display:block;background:#fff}' +
      '.cfp-thumb span{position:absolute;right:4px;bottom:4px;width:22px;height:22px;border-radius:50%;background:rgba(0,0,0,.55);color:#fff;font:14px/22px sans-serif;text-align:center}' +
      '.cfp-overlay{position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.65);display:none;align-items:center;justify-content:center;padding:16px}' +
      '.cfp-overlay.is-on{display:flex}' +
      '.cfp-overlay img{width:min(92vw,80vh);height:auto;border-radius:16px;background:#fff;box-shadow:0 10px 40px rgba(0,0,0,.35)}' +
      '.cfp-close{position:absolute;top:14px;right:14px;width:40px;height:40px;border:0;border-radius:50%;background:#fff;color:#222;font:22px/40px sans-serif;cursor:pointer}';
    document.head.appendChild(css);

    var thumb = document.createElement('button');
    thumb.type = 'button';
    thumb.className = 'cfp-thumb';
    thumb.setAttribute('aria-label', "Agrandir l'aperçu");
    thumb.innerHTML = '<img alt="Aperçu de votre personnalisation"><span>+</span>';
    var overlay = document.createElement('div');
    overlay.className = 'cfp-overlay';
    overlay.innerHTML = '<button type="button" class="cfp-close" aria-label="Fermer">×</button><img alt="Aperçu de votre personnalisation">';
    document.body.appendChild(thumb);
    document.body.appendChild(overlay);
    var thumbImg = thumb.querySelector('img');
    var bigImg = overlay.querySelector('img');

    // cssPx : taille d'affichage souhaitee, rendue a la densite de l'ecran (net sur mobile)
    function snap(cssPx) {
      try {
        if (!stage.visible()) return null;
        var dpr = Math.min(window.devicePixelRatio || 1, 3);
        var ratio = Math.min((cssPx * dpr) / (stage.width() || 1), 4);
        var c = stage.toCanvas({ pixelRatio: ratio });
        var o = document.createElement('canvas');
        o.width = c.width;
        o.height = c.height;
        var x = o.getContext('2d');
        x.fillStyle = '#fff';
        x.fillRect(0, 0, o.width, o.height);
        x.drawImage(c, 0, 0);
        return o.toDataURL('image/jpeg', 0.92);
      } catch (e) {
        return null;
      }
    }

    function bigSize() {
      return Math.min(window.innerWidth * 0.92, window.innerHeight * 0.8, 700);
    }

    var galleryVisible = true;
    var timer = null;
    function refresh() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        harden();
        if (wantThumb) {
          var s = snap(96);
          if (s) thumbImg.src = s;
          thumb.classList.toggle('is-on', !!thumbImg.getAttribute('src'));
        }
        if (overlay.classList.contains('is-on')) {
          var b = snap(bigSize());
          if (b) bigImg.src = b;
        }
      }, 250);
    }

    // La vignette ne s'affiche que si une image de l'apercu a pu etre generee
    var wantThumb = false;
    function update() {
      var show = !galleryVisible && window.innerWidth <= MAX_WIDTH && !overlay.classList.contains('is-on');
      var was = wantThumb;
      wantThumb = show;
      if (!show) thumb.classList.remove('is-on');
      else if (thumbImg.getAttribute('src')) thumb.classList.add('is-on');
      if (show && !was) refresh();
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        galleryVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.2 }).observe(anchor);
    }
    window.addEventListener('resize', update);

    ['change', 'input', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target && e.target.closest && e.target.closest('[class*="tpo"]')) {
          refresh();
          setTimeout(refresh, 900);
          setTimeout(refresh, 2000);
        }
      }, true);
    });

    thumb.addEventListener('click', function () {
      var b = snap(bigSize());
      if (b) bigImg.src = b;
      overlay.classList.add('is-on');
      update();
    });
    overlay.addEventListener('click', function () {
      overlay.classList.remove('is-on');
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
